// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__GaJqr","content":"styles_content__1AuLb","checkbox":"styles_checkbox__2BADY","checkboxLabel":"styles_checkboxLabel__OQy26"};